/**
 * @file Automatically generated by barrelsby.
 */

export * from './header.component';
